"use strict";

exports.__esModule = true;

exports.default = function (obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/helpers/objectDestructuringEmpty.js
// module id = 215
// module chunks = 64